import { initGsapAnimations, initPageAnimations } from './gsap.js';
import { initDataLayer } from './tags.js';
import { initQuiz } from './quiz.js';
import { initMaps } from './maps.js';

window.addEventListener('load', init);

function init(e) {

  initDataLayer();
  initQuiz();
  initMaps();

  /*==MENU ACESSIBILIDADE==*/
  var btA11y = document.querySelector('#a11y .a11y__btn');
  var wrapperA11y = document.getElementById('a11y');
  var btFecharA11y = document.querySelector('#a11y .a11y__close');

  btA11y.addEventListener('click', abrirA11y);
  // btFecharA11y.addEventListener('click', fecharA11y);

  function abrirA11y() {
    wrapperA11y.classList.toggle('active');
  }

  // function fecharA11y() {
  //   wrapperA11y.classList.remove('active');
  // }

  sessionStorage.getItem('contrast') && +sessionStorage.getItem('contrast') && document.body.classList.add('has--high-contrast');

  if (document.querySelector('[data-contrast]')) {
    document.querySelector('[data-contrast]').addEventListener(
      'click',
      () => {
        document.body.classList.toggle('has--high-contrast');

        sessionStorage.setItem('contrast', document.body.classList.contains('has--high-contrast') ? 1 : 0);
      },
      true
    );
  }

  const rootElement = document.documentElement;

  // Seleciona os botões uma única vez
  const decreaseButton = document.querySelector('[data-fontsize-decrease]');
  const increaseButton = document.querySelector('[data-fontsize-increase]');

  // --- CONFIGURAÇÕES ---
  const minSize = 8; // Tamanho mínimo em pixels
  const maxSize = 12; // Tamanho máximo em pixels
  const step = 1;     // Quanto aumentar/diminuir a cada clique

  /**
   * Aplica o novo tamanho da fonte e salva na sessão.
   * @param {number} size - O novo tamanho da fonte em pixels.
   */
  const applyFontSize = (size) => {
    rootElement.style.fontSize = `${size}px`;
    sessionStorage.setItem('fontsize', size);
  };

  // Ao carregar a página, verifica se há um tamanho salvo na sessão
  const savedSize = sessionStorage.getItem('fontsize');
  if (savedSize) {
    applyFontSize(parseInt(savedSize));
  }

  // Evento para o botão de diminuir a fonte
  if (decreaseButton) {
    decreaseButton.addEventListener('click', (event) => {
      event.preventDefault();
      // Pega o tamanho da fonte atual computado do elemento <html>
      const currentSize = parseInt(window.getComputedStyle(rootElement).fontSize);

      if (currentSize > minSize) {
        applyFontSize(currentSize - step);
      }
    });
  }

  // Evento para o botão de aumentar a fonte
  if (increaseButton) {
    increaseButton.addEventListener('click', (event) => {
      event.preventDefault();
      const currentSize = parseInt(window.getComputedStyle(rootElement).fontSize);

      if (currentSize < maxSize) {
        applyFontSize(currentSize + step);
      }
    });
  }

  const BannerHero = document.querySelectorAll('.banner-hero .swiper');

if (BannerHero.length > 0) { //importante para quando for possível repetir o bloco na mesma página
  for (let [i, elBannerHero] of BannerHero.entries()) {

    new Swiper(elBannerHero, {
      centerInsufficientSlides: true,
          pagination: false,
          enabled: true,
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true, 
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
    });
  }
}

const CarrosselHover = document.querySelectorAll('.carrossel-hover .swiper');

if (CarrosselHover.length > 0) { //importante para quando for possível repetir o bloco na mesma página
  for (let [i, elCarrosselHover] of CarrosselHover.entries()) {

    new Swiper(elCarrosselHover, {
      
      enabled: false,
      breakpoints: {
        1220: {
          centerInsufficientSlides: true,
          pagination: false,
          enabled: true,
          slidesPerView: 4,
          spaceBetween: 20,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
          },
        }
      }
    });
  }
}

const CarrosselExpansivel = document.querySelectorAll('.carrossel-exp .swiper');

if (CarrosselExpansivel.length > 0) { //importante para quando for possível repetir o bloco na mesma página
  for (let [i, elCarrosselExpansivel] of CarrosselExpansivel.entries()) {

    new Swiper(elCarrosselExpansivel, {
          // spaceBetween: 20,
          slidesPerView: 'auto',
          slideToClickedSlide: true,
          // loop: true,
          // centeredSlides: true,
          centeredSlides: false,
          snapToSlideEdge: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
          },
          on: {
            // Quando o slide ativo mudar e a transição do Swiper acabar
            transitionEnd: function () {
              // Forçamos o Swiper a recalcular os tamanhos e posições.
              // Isso fará a fila toda 'pular' para a posição correta.
              this.update();
            },
          },
    });

    var slidesExp = elCarrosselExpansivel.querySelectorAll('.swiper-slide');

    slidesExp.forEach(elSlideExp => {
      elSlideExp.addEventListener('click', abrirSlideExp);

      function abrirSlideExp() {
        event.target.closest('.swiper-slide').classList.toggle('swiper-slide-aberto');
      }
    });
  }
}



const CarrosselNovidades = document.querySelectorAll('.bloco-novidades .swiper');

if (CarrosselNovidades.length > 0) { //importante para quando for possível repetir o bloco na mesma página
  for (let [i, elCarrosselNovidades] of CarrosselNovidades.entries()) {

    new Swiper(elCarrosselNovidades, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      breakpoints: {
        1024: {
          enabled: false,
        },
      }
    });
  }
}

const CarrosselRelacionadas = document.querySelectorAll('.post-mais .swiper');

if (CarrosselRelacionadas.length > 0) { //importante para quando for possível repetir o bloco na mesma página
  for (let [i, elCarrosselRelacionadas] of CarrosselRelacionadas.entries()) {

    new Swiper(elCarrosselRelacionadas, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      breakpoints: {
        1024: {
          enabled: false,
        },
      }
    });
  }
}

const CarrosselTimeline = document.querySelectorAll('.timeline .swiper');

if (CarrosselTimeline.length > 0) { //importante para quando for possível repetir o bloco na mesma página
  for (let [i, elCarrosselTimeline] of CarrosselTimeline.entries()) {

    new Swiper(elCarrosselTimeline, {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
        renderBullet: function (index, className) {
          var datas = elCarrosselTimeline.querySelectorAll('.timeline-card__data');
          var dataActive = datas[index].textContent.trim();
          return `<span class="${className}"><span>${dataActive}</span></span>`;
        },
      },
    });
  }
}

const CarrosselSedes = document.querySelectorAll('.sede-grid .swiper');

if (CarrosselSedes.length > 0) { //importante para quando for possível repetir o bloco na mesma página
  for (let [i, elCarrosselSedes] of CarrosselSedes.entries()) {

    new Swiper(elCarrosselSedes, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      observer: true,         // Monitora alterações de elementos filhos no DOM
      observeParents: true,   // Monitora alterações no elemento pai
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
    });
  }
}




//ABRIR MENU
var btMenu = document.getElementById('bt-menu');

btMenu.addEventListener('click', abrirMenu);

function abrirMenu() {
  var navMenu = document.getElementById('nav-menu');
  navMenu.classList.toggle('active');
  document.body.classList.toggle('has--menu');
}

//ABRIR BUSCA MENU
var btBusca = document.getElementById('bt-busca');

btBusca.addEventListener('click', abrirBusca);

function abrirBusca() {
  var boxBusca = document.getElementById('box-busca');
  boxBusca.classList.toggle('active');
}

//ABRIR FILTROS PUBLICACOES
var pubFiltros = document.getElementById('pubFiltros');

if(pubFiltros) {
  pubFiltros.addEventListener('click', abrirFiltrosPub);

function abrirFiltrosPub() {
  var boxFiltros = document.getElementById('boxFiltros');
  boxFiltros.classList.toggle('active');
}
}

//ABRIR ITENS FOOTER
var itensFooter = document.querySelectorAll('.footer__col h3');

itensFooter.forEach(itemFooter => {
    itemFooter.addEventListener('click', abrirFooter);
    function abrirFooter() {
        event.target.closest('.footer__col').querySelector('div').classList.toggle('active');
      }
  });


}

/*==COOKIES==*/


(function () {
    'use strict';

    var cookieAlert = document.getElementById('cookiealert');
    var acceptCookies = document.getElementById('acceptcookies');

    if (!cookieAlert) {
       return;
    }

    cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

    // Show the alert if we cant find the "acceptCookies" cookie
    if (!getCookie('acceptCookies')) {
        cookieAlert.classList.add('show'); 
    }

    // When clicking on the agree button, create a 1 year
    // cookie to remember user's choice and close the banner
    acceptCookies.addEventListener('click', function () {
        setCookie('acceptCookies', true, 365);
        cookieAlert.classList.remove('show');
    });

    // Cookie functions from w3schools
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    function getCookie(cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
})();


//ABRIR MENU SHARE
var boxShare = document.querySelector('.post-share');

if(boxShare) {
  var btShare = boxShare.querySelector('.post-heading__share');
  btShare.addEventListener('click', abrirShare);

function abrirShare() {
  boxShare.querySelector('.post-share__box').classList.toggle('active');
}
}

//BT COPIAR LINK POSTS

var btCopiar = document.querySelector('.bt-copy');

if (btCopiar) {
  btCopiar.addEventListener('click', copiarSocial);

  function copiarSocial() {
    var textoCopiado = btCopiar.getAttribute('data-copy');
    navigator.clipboard.writeText(textoCopiado);
    btCopiar.classList.add('bt-copiado');
  }
}